<script>import SVG from "../SVG.svelte";
export let props;
let invalidRules = [];
$: if (props && props.validation && props.validation.rules) {
  let tmpInvalidRules = [];
  props.validation.rules.forEach((r) => {
    if (!r.valid) {
      tmpInvalidRules.push(r);
    }
  });
  invalidRules = tmpInvalidRules;
}
</script>

{#if props && props.validation && props.validation.rules}
  <div class="ml-3 mt-2">
    {#if ((invalidRules.length === 1 && props.validation.rules.length === 1) || (props.validation.rules.length === 2 && props.required)) && invalidRules[0] && invalidRules[0].label}
      <div class="text-danger">
        {@html invalidRules[0].label}
      </div>
    {:else}
      <div class="space-y-2">
        {#each props.validation.rules as rule}
          {#if rule.label}
            <div class="flex items-center {rule.valid ? 'text-success' : 'text-danger'}">
              <SVG classNames="mr-3" name={rule.valid ? 'check_square' : 'close_square'} />
              <span>{@html rule.label}</span>
            </div>
          {/if}
        {/each}
      </div>
    {/if}
  </div>
{/if}
